import { APP_BASE_HREF } from '@angular/common';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatLegacyAutocompleteModule as MatAutocompleteModule } from '@angular/material/legacy-autocomplete';
import { MatLegacyChipsModule as MatChipsModule } from '@angular/material/legacy-chips';
import { MatLegacyMenuModule as MatMenuModule } from '@angular/material/legacy-menu';
import { MatLegacySelectModule as MatSelectModule } from '@angular/material/legacy-select';
import { MatLegacySnackBarModule as MatSnackBarModule } from '@angular/material/legacy-snack-bar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { AkitaNgDevtools } from '@datorama/akita-ngdevtools';
import { FaIconLibrary } from '@fortawesome/angular-fontawesome';
import { fal } from '@fortawesome/pro-light-svg-icons';
import { AvatarModule } from '@y42/core/avatar';
import { environment } from '@y42/environment';
import { GitHttpHeaderInterceptor } from '@y42/feature/git';
import { IntercomControlService } from '@y42/intercom';
import { OAuthModule } from 'angular-oauth2-oidc';
import { IntercomModule } from 'ng-intercom';
import { ColorPickerModule } from 'ngx-color-picker';
import { MarkdownModule } from 'ngx-markdown';
import { OrgApiUrlInterceptor } from '../org-space/interceptors/org-api-url.interceptor';
import { Y42ServiceWorkerModule } from '../vendor/service-worker';
import { APP_INITIALIZER_PROVIDER } from './app-initializer';
import { ConnectionStatusService } from './services/connection-status.service';

@NgModule({
  imports: [
    HttpClientModule,
    OAuthModule.forRoot(),
    IntercomModule.forRoot({
      appId: 'zr2vdgwu', // from your Intercom config
      updateOnRouterChange: true, // will automatically run `update` on router event changes. Default: `false`
    }),
    environment.production_build ? [] : AkitaNgDevtools.forRoot(),
    Y42ServiceWorkerModule,

    MatSnackBarModule,
    MatDialogModule,
    AvatarModule,
    MatTooltipModule,
    MatMenuModule,
    MatSelectModule,
    ColorPickerModule,
    MarkdownModule.forRoot(),
    MatDatepickerModule,
    MatAutocompleteModule,
    MatChipsModule,
  ],
  providers: [
    APP_INITIALIZER_PROVIDER,
    {
      provide: APP_BASE_HREF,
      useValue: environment.url.app,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: OrgApiUrlInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: GitHttpHeaderInterceptor,
      multi: true,
    },
  ],
})
export class CoreModule {
  constructor(
    readonly intercomControlService: IntercomControlService,
    readonly connectionStatusService: ConnectionStatusService,
    readonly library: FaIconLibrary,
  ) {
    library.addIconPacks(fal);
  }
}
